export const buildProfilerUrl = (action) => {
  const { chain, address, tab } = action.params;
  return `/wallet-profile/${chain}/${address}?tab=${tab}`;
};

export const buildContractAnalysisUrl = (action) => {
  const { chain, address, tab } = action.params;
  return `/contract-analysis/${chain}/${address}?tab=${tab}`;
};

export const buildDecoderUrl = (action) => {
  const { chain, txnHash, tab } = action.params;
  return `/transaction-decoder/${chain}/${txnHash}?tab=${tab}`;
};

